import { messageQuickActionQueryKeys as e } from "./useMessageQuickActionQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { messageAutomationsApi as r } from "@maat/api-chat";
//#region src/messageQuickActions/useApplyMessageQuickActionMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ templateKey: e, listingId: t, value: n }) => r.applyQuickAction(e, {
			listing_id: t,
			value: n
		}),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.list(n.listingId) });
		}
	});
};
//#endregion
export { i as useApplyMessageQuickActionMutation };
